window.luiReferenceControllers = window.luiReferenceControllers || [];
window.luiReferenceControllers.push(function (application, Stimulus) {
    application.register("comp_references_single_chaloupky", class extends Stimulus.Controller {
    async connect() {
        const self = this;

        this._cards = self.targets.findAll('card')
        this._gsapTweens = [];
        await importScript([cdnjs.gsap, cdnjs.gsapScrollTrigger]);
        gsap.registerPlugin(ScrollTrigger);

        ScrollTrigger.matchMedia({
            '(min-width: 60em)': () => {
                const timeline = gsap.timeline({
                    scrollTrigger: {
                        trigger: self.targets.find('scene'),
                        start: 'top-=150 top',
                        end: `+${100 * self._cards.length}%`,
                        scrub: true,
                        pin: true,
                        markers: false
                    }
                })

                this._gsapTweens.push(timeline)

                self._cards.forEach((card) => {
                    ScrollTrigger.saveStyles(card)
                })

                timeline.fromTo(self._cards[0],
                    {
                        translateY: 0,
                        scale: 1,
                    },
                    {
                        translateY: '-21%',
                        scale: 0.7
                    }
                )

                timeline.fromTo(self._cards[1],
                    {
                        translateY: '150%',
                        scale: 1,
                    },
                    {
                        translateY: '-11%',
                        scale: 0.8
                    },
                    '>-85%'
                )

                timeline.fromTo(self._cards[2],
                    {
                        translateY: '150%',
                        scale: 1,
                    },
                    {
                        translateY: '0%',
                        scale: 0.9,
                    },
                    '>-55%'
                )

                timeline.fromTo(self._cards[3],
                    {
                        translateY: '150%'
                    },
                    {
                        translateY: '11%'
                    },
                    '>-25%'
                )
            }
        })
    }

    disconnect() {
        if (!this._gsapTweens) {
            return
        }

        this._gsapTweens.forEach((tween) => {
            if (tween.scrollTrigger) {
                tween.scrollTrigger.kill()
            }

            tween.kill()
        })

        this._gsapTweens = []
    }
})
});
window.luiRegisterReferenceControllers && window.luiRegisterReferenceControllers();
